import Vue from 'vue'
import Router from 'vue-router'


const Ero403  = () => import('@/pages/403')
const Ero404  = () => import('@/pages/404')
const Ero500  = () => import('@/pages/500')


import Layout from '@/pages/layout'
import Login from '@/pages/Login'


const dashboard = () => import('@/pages/dashboard') // 首页
const about = () => import('@/pages/about') // 关于我们
const authentication  = () => import('@/pages/authentication') // 认证中心
const mcn = () => import('@/pages/mcn') // MCN机构
const shop = () => import('@/pages/shop') // 快速开店
const advertisement = () => import('@/pages/advertisement') // 广告投放
const platform = () => import('@/pages/platform') // 开放平台
const notice = () => import('@/pages/notice') // 公告声明
const application = () => import('@/pages/application') // 应用下载




Vue.use(Router)

export default new Router({
    // mode:'history', // 去掉页面锚点 (#)  默认hash
    base: '/',
        routes: [
        // 404
        {
            path: '/404',
            name:'404',
            component: Ero404,
            meta:{
                title:'抱歉，您访问的页面不存在'
            }
        },
        // 403
        {
            path: '/403',
            name:'403',
            component: Ero403,
            meta:{
                title:'抱歉，你无权访问该页面'
            }
        },
        // 500
        {
            path: '/500',
            name:'500',
            component: Ero500,
            meta:{
                title:'抱歉，服务器出错了'
            }
        },
        // 登录
        {
            path: '/login',
            name:'/login',
            component: Login,
            meta:{
                title:'登录'
            }
        },
        // 首页
        {
            path: '/',
            name:'Layout',
            component: Layout,
            title: "首页",
            redirect: "/dashboard",
            children: [
                {
                    path: '/dashboard',
                    name: '首页',
                    component: dashboard,
                },
                {
                    path: '/about',
                    name: '关于我们',
                    component: about,
                },
                {
                    path: '/authentication',
                    name: '认证中心',
                    component: authentication,
                },
                {
                    path: '/mcn',
                    name: 'MCN机构',
                    component: mcn,
                },
                {
                    path: '/shop',
                    name: '快速开店',
                    component: shop,
                },
                {
                    path: '/advertisement',
                    name: '广告投放',
                    component: advertisement,
                },
                {
                    path: '/platform',
                    name: '开放平台',
                    component: platform,
                },
                {
                    path: '/notice',
                    name: '公告声明',
                    component: notice,
                },
                {
                    path: '/application',
                    name: '应用下载',
                    component: application,
                }

            ],
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]

})
